export default __webpack_public_path__ + "static/media/Card-LatitudeEcoMastercard.d341bdc9.png";